import styled from 'styled-components'
import { DEVICE, NAVIGATION_BAR_COLLAPSED_SIZE } from '../../../util/constants'

export const NavBar = styled.aside`
  background-color: var(--content-background-dark-blue);
  width: 100vw;
  flex-basis: ${NAVIGATION_BAR_COLLAPSED_SIZE.mobile.height}px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 22px;
  align-items: center;
  flex-shrink: 0;

  @media ${DEVICE.tabletL} {
    flex-basis: ${NAVIGATION_BAR_COLLAPSED_SIZE.desktop.width}px;
    padding: unset;
    height: 100vh;
    justify-content: unset;
    flex-direction: column;
    align-items: center;
  }
`

const BUTTON_COMMON = `
  display: inline-block;
  background-color: transparent;
  color: var(--content-background-light);
  :hover {
    color: var(--graphic-accent-purple-1);
  }
  font-family: 'Open Sans';
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: bold;
  font-style: normal;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 51px;
`

export const HamburgerButton = styled.button`
  ${BUTTON_COMMON}
  stroke: var(--content-background-light);

  :hover {
    stroke: var(--graphic-accent-purple-1);
  }

  @media ${DEVICE.tabletL} {
    margin-top: 61px;
  }
`

export const SearchButton = styled.button`
  ${BUTTON_COMMON}
  fill: var(--content-background-light);

  :hover {
    fill: var(--graphic-accent-purple-1);
  }

  @media ${DEVICE.tabletL} {
    margin-top: calc(50vh - 61px - 51px - 26px);
  }
`
